var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyIndustriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30005 3.56249C1.30005 2.86522 1.86529 2.29999 2.56255 2.29999H5.18755C5.88481 2.29999 6.45005 2.86522 6.45005 3.56249V6.88831L8.63474 5.49804L8.63478 5.49802C9.47451 4.96373 10.575 5.56724 10.575 6.56317V6.88831L12.7597 5.49804L12.7598 5.49802C13.5995 4.96374 14.7 5.56719 14.7 6.56317V12.9375C14.7 13.6348 14.1348 14.2 13.4375 14.2H2.56255C1.86529 14.2 1.30005 13.6348 1.30005 12.9375V3.56249ZM2.70005 3.69999V12.8H13.3V6.81364L10.2509 8.75404C10.0353 8.89121 9.76217 8.90005 9.5382 8.7771C9.31424 8.65416 9.17505 8.41897 9.17505 8.16348V6.81364L6.12586 8.75404C5.91032 8.89121 5.63716 8.90005 5.4132 8.7771C5.18924 8.65416 5.05005 8.41897 5.05005 8.16348V3.69999H2.70005Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIndustriesIcon);
export default __webpack_public_path__ + "static/media/EnergyIndustries_icon.a3f585141a56bba98acc8e0ae114149a.svg";
export { ForwardRef as ReactComponent };